var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHirlLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 35,
    viewBox: "0 0 51 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58958 15.3391C7.55286 15.3391 6.19504 16.9409 6.19504 19.4656V34.9532H0V0H6.19504V12.8675H6.48147C7.35133 11.0217 9.33501 9.90783 11.8067 9.90783C15.9226 9.90783 18.7761 13.0584 18.7761 18.0123V34.9532H12.581V19.1792C12.581 16.803 11.5202 15.3497 9.57899 15.3497L9.58958 15.3391Z",
    fill: "#1E191A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1502 16.5388C24.0788 16.5388 23.0074 16.2948 22.0315 15.8599V34.9542H28.269V15.8811C27.293 16.316 26.2323 16.5388 25.1502 16.5388Z",
    fill: "#1E191A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1493 5.46466C27.2497 5.46466 29.053 7.16193 29.053 9.28353C29.053 11.4051 27.2497 13.113 25.1493 13.113C23.0489 13.113 21.2986 11.3733 21.2986 9.28353C21.2986 7.19376 23.1019 5.46466 25.1493 5.46466Z",
    fill: "#1E191A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5803 9.94043C34.4432 9.94043 31.5685 13.091 31.5685 18.0343V34.954H37.8059V19.2012C37.8059 14.8943 41.2535 15.9127 41.5081 15.9445V10.3754C40.8717 10.1208 39.6729 9.94043 38.5803 9.94043Z",
    fill: "#1E191A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.021 0V34.9532H50.2479V0H44.021Z",
    fill: "#1E191A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHirlLogoDark);
export default __webpack_public_path__ + "static/media/HirlLogoDark.af8bdbc21d410267a7bad52132154055.svg";
export { ForwardRef as ReactComponent };